import {Injectable} from '@angular/core';

/**
 * Сервис с расчетами для пагинации страниц.
 */

@Injectable()
export class PaginationUIService {

    /**
     * Строим массив ссылок пагинации.
     * Если страниц менее maxVisiblePages, то показываем все старницы.
     * Если ссылок больше maxVisiblePages, то ссылки страницы будут выглядеть следующим образом:
     * 1. Текущая страница вначале: показываем первые страницы, затем ..., затем последние страницы
     * 1, 2, 3, 4 (текущая), 5, 6, ..., 72, 73, 74
     * 2. Текущая страница не в начале: показываем первые страницы, затем ..., затем еще страницы,
     * включая текущуюю, затем ... и последние страницы
     * 1, 2, ..., 13, 44 (текущая), 15, 16, ..., 73, 74
     * 3. Текущая страница в конце списка: показываем первые страницы, затем ..., затем последние страницы,
     * включая текущуюю
     * 1, 2, 3 ..., 69, 70 (текущая), 71, 72, 73, 74
     * @returns {Array}
     */
    getPagesLinks(pagesCount, page, maxVisiblePages = 10): any[] {
        let links = [];

        const totalPagesLinks = Array(+pagesCount).fill(null).map((item, index) => {
            return {
                title: index + 1,
                page: index + 1
            };
        });

        if (totalPagesLinks.length > maxVisiblePages) {
            const start = 0;
            const end = pagesCount;
            const current = page;

            /**
             * Балансировщик для четного/нечетного числа страниц для отображения
             * @type {number}
             */
            const evenBalancer = maxVisiblePages % 2;

            /**
             * Некая идеализированная величина количества подряд идущих страниц, относительно
             * которой будут строиться условия, сколько элементов взять и как отображать пагинацию.
             * @type {number}
             */
            const queryLength = Math.floor(maxVisiblePages / 3) || 1;

            // Если current в начале
            if (current <= Math.ceil(queryLength * 1.5)) {
                links = links.concat(totalPagesLinks.slice(start, (maxVisiblePages - queryLength)));
                links.push({
                    title: '...',
                    page: Math.ceil(end / 2 + queryLength)
                });
                links = links.concat(totalPagesLinks.slice(-queryLength + 1));
            // Если current в конце
            } else if (current > end - Math.ceil(queryLength * 1.5)) {
                links = links.concat(totalPagesLinks.slice(start, queryLength - 1));
                links.push({
                    title: '...',
                    page: Math.floor(end / 2 - queryLength) + 1
                });
                links = links.concat(totalPagesLinks.slice(end - (maxVisiblePages - queryLength), end));
            // Если current в середине
            } else {
                /**
                 * startAndEndPartsCount
                 * Сколько брать ссылок в начале и конце. Делим на 4, так как в идеальной ситуации у нас 4 куска пагинации:
                 * начало + первая половина середины до current + вторая половина середины после current + оставшиеся в конце страницы
                 * Отнимает при расчете 2, так как есть две страницы "..."
                 *
                 * centralPartCount - Сколько брать в середине.
                 * На середину Нужно взять то количество страниц, которое останется, если от максимально возможного
                 * количества отнять две страницы "...", и страницы в начале и конце списка.
                  */
                const startAndEndPartsCount = Math.ceil((maxVisiblePages - 2) / 4);
                const centralPartCount = Math.floor((+maxVisiblePages - 2 - (2 * startAndEndPartsCount)) / 2);
                links = links.concat(totalPagesLinks.slice(start, startAndEndPartsCount));
                links.push({
                    title: '...',
                    page: current - Math.ceil(current / 2)
                });
                links = links.concat(totalPagesLinks.slice(current - centralPartCount - evenBalancer, current + centralPartCount));
                links.push({
                    title: '...',
                    page: current + Math.ceil((pagesCount - current) / 2)
                });
                links = links.concat(totalPagesLinks.slice(end - startAndEndPartsCount, end));
            }
        } else {
            links = totalPagesLinks;
        }

        return links;
    }
}
